import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useHistory
import 'bootstrap/dist/css/bootstrap.min.css';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress'; // ← NEW

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AccountForm = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(false); // ← NEW
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    accountName: '', // Corrected to match the state variable and input name
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNextClick = async (e) => {

    e.preventDefault(); // Prevent the default form submission behavior

    setLoading(true); // ← NEW: start loader before API call

    try {

      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Default`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accountName: formData.accountName,

        }),
      });

      if (response.ok) {
        // Login successful, navigate to the dashboard page or perform any other necessary actions
        const responseData = await response.json();
        const { token, userOutput } = responseData;
        sessionStorage.setItem('token1', token);
        sessionStorage.setItem('clientLogo', userOutput.clientLogo);
        sessionStorage.setItem('clientCode', userOutput.clientCode);

               const isTenantClient =
          String(userOutput.clientCode || '').trim().toLowerCase() === 'waralsadmin';
        navigate(isTenantClient ? '/tenantlogin' : '/login');
        
      } else {
        // Handle login failure here (e.g., show an error message)
        console.error("Login failed");
        // alert('Invalid credentials');
        setSnackbarMessage('Invalid credentials');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      // Handle API request error here
      console.error("API request error:", error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    } finally {
      setLoading(false); // ← NEW: always stop loader, success or error
    }
  }

  return (
    <div className="home">
      <div className="container-fluid d-flex justify-content-end align-items-center vh-100 pr-5">
        <div className="card" style={{ width: '400px', height: '300px', marginRight: '60px', boxShadow: '0 15px 20px rgba(0, 0, 0, 0.2)', borderRadius: '5px', filter: 'drop-shadow(5px 5px 5px orange)' }}>
          <div className="card-body d-flex flex-column justify-content-center">
            <h4 className="card-title text-center">Account Information</h4>
           <form onSubmit={handleNextClick}>
              <div className="my-3">
                <label htmlFor="accountName" className="form-label">
                  Account Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="accountName"
                  name="accountName"
                  placeholder="Enter your account name"
                  value={formData.accountName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="d-grid gap-2">
                {/* ← CHANGED: disabled + spinner while loading */}
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleNextClick}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <CircularProgress
                        size={16}
                        sx={{ color: '#fff', mr: 1, verticalAlign: 'middle' }}
                      />
                      {' '}Loading...
                    </>
                  ) : 'Next'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};


export default AccountForm;